var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex",class:[_vm.alignItems]},[_c('span',{staticClass:"font-weight-bold mr-5px"},[_vm._v(_vm._s(_vm.title)+":")]),_vm._v(" "+_vm._s(_vm.value || '-')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }